var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "15px",
    viewBox: "0 0 24 15",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-battery-copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15L2.5 15C1.121 15 0 13.878 0 12.5L0 2.5C0 1.122 1.121 0 2.5 0L19.5 0C20.879 0 22 1.122 22 2.5L22 3L22.491 3C23.318 3 23.991 3.673 23.991 4.5L23.991 10.5C23.991 11.327 23.318 12 22.491 12L22 12L22 12.5C22 13.878 20.879 15 19.5 15ZM2.5 1C1.673 1 1 1.673 1 2.5L1 12.5C1 13.327 1.673 14 2.5 14L19.5 14C20.327 14 21 13.327 21 12.5L21 11.5C21 11.224 21.224 11 21.5 11L22.491 11C22.766 11 22.991 10.776 22.991 10.5L22.991 4.5C22.991 4.224 22.766 4 22.491 4L21.5 4C21.224 4 21 3.776 21 3.5L21 2.5C21 1.673 20.327 1 19.5 1L2.5 1Z",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9L0.5 9C0.224 9 0 8.776 0 8.5L0 0.5C0 0.224 0.224 0 0.5 0L3.5 0C3.776 0 4 0.224 4 0.5L4 8.5C4 8.776 3.776 9 3.5 9ZM1 8L3 8L3 1L1 1L1 8Z",
    transform: "translate(3 3)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBattery);
export default __webpack_public_path__ + "static/media/low-battery.e65db9bf1eb4e54a1e14f6057c3bce74.svg";
export { ForwardRef as ReactComponent };